<template>
  <div class="service-unscheduled-flow-alarm">
    <h2>
      {{ $t('messages.alarms.serviceUnscheduledFlowAlarm.title') }}
    </h2>

    <alarm-status
      :alarm="alarm"
      :alarm-active="computedAlarmIsActive"
    />

    <flow-gauge-component :store = "store" />

    <alert-handler-list
      class="g-alarm-handler__row"
      :list="alarmData.list"
      :title="'Programs and stations which ran before the alarm; i.e. stations which might be stuck open and cause the unscheduled flow alarm'"
    />

    <hr>

    <!-- <div class="g-alarm-handler__row">
      <h3 class="g-text g-text--center">
        {{ $t('messages.alarms.suggestion') }}
      </h3>
      <p>
        {{ $t('messages.alarms.serviceUnscheduledFlowAlarm.suggestion') }}
      </p>
    </div> -->

    <div class="g-text g-text--center">
      <selective-survey-button :list="alarmData.list" />
    </div>
  </div>
</template>

<script>
import {ServiceAlarm} from '@/assets/javascript/mixins/ServiceAlarm'
import FlowGauge from '@/components/FlowGauge.vue'
import ServiceSelectiveSurveyButton from '@/components/elements/ServiceSelectiveSurveyButton'

export default {
  name: 'ServiceUnscheduledFlowAlarm',
  components: {
    'flow-gauge-component': FlowGauge,
    'selective-survey-button': ServiceSelectiveSurveyButton
  },
  mixins: [ServiceAlarm],
  data() {
    return {
      information: {
        start: '1:10pm',
        valveStatus: true,
        gpm: 8.4
      }
    }
  }
}
</script>